export default __webpack_public_path__ + "static/media/bank.b08acdd2.png";